import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import img from '../assets/others/11102062.png'

const Registernow = () => {
  return (
    <div>
    <Header/>  
    <main>
    <section className='section-banner pg-banner mb-5'>
            <div class="container text-center">
                          <div class="row justify-content-around ">
                              <div class="col-md p-5">
                                <div class="pg-title-sec">
                                    <h1 className='pg-title pb-3'>REGISTER NOW
                                    </h1>
                                 </div>
                              </div>
                          </div>
                          <div className='row justify-content-center'>
                          <div class="col-lg img-radius">
                            <img src={img} alt=''/>
                          </div>
                          <div class="col-lg img-radius">
                          <div className='ctn-frm'>
                <h2 class="mb-3">Lest Connect</h2>
                <iframe
                                    aria-label='Register Now'
                                    width="100%"
                                    height="850"
                                    src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                                    frameborder="0" 
                                    title='Register Now'
                                   
                                />
                </div>
                          </div>
                          </div>
            </div>
          </section>
    </main>
    <Enrollaction/>
    <Partnersec/> 
    <Footer/>   
    </div>
  )
}

export default Registernow